import { handleActions } from 'redux-actions'

import { actions } from '../actions/profiles'

const defaultState = {
    profile: {
        bio: undefined,
        education: undefined,
        email: undefined,
        firstName: undefined,
        language: 'en',
        lastName: undefined,
        phone: undefined,
        picture: undefined,
        sessionLink: undefined,
        timezone: 'UTC'
    }
}

const resetProfile = (_state, _action) => {
    return defaultState
}

const setProfile = (state, action) => {
    return { ...state, profile: { ...state.profile, ...action.payload } }
}

export default handleActions({
    [actions.resetProfile]: resetProfile,
    [actions.setProfile]: setProfile
}, defaultState)



// WEBPACK FOOTER //
// ./src/store/reducers/profiles.js